import React, { useState, Fragment, useContext, useEffect } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import RegistrationContext from '../context/registrationContext';
import { Modal, Button } from 'react-bootstrap';

const Form = () => {

    const { registrationComplete } = useContext(RegistrationContext);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [form, setForm] = useState({
        name: '',
        email: '',
        designation: '',
        location: '',
        schoolName: '',
        schoolAddress: '',
        others: '',
        phone: ''
    });

    const [questionSection, setQuestionSection] = useState({
        info: '',
        others: ''
    });

    const { info, others } = questionSection

    const [number, setNumber] = useState('');

    const [checkbox, setCheckbox] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const { name, email, designation,
        location, schoolName,
        schoolAddress } = form;

    const onChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (info === 'others' && others === '') {
            handleShow();
        } else if (number === '' || number === undefined || designation === '') {
            handleShow();
        }
        else {
            sendMail();
            // messageCloud();
            setBtnState(true);
        }
    }

    // const messageCloud = async () => {
    //     try {
    //         const config = {
    //             headers: {
    //                 'Content-type': 'application/json'
    //             }
    //         }

    //         const body = JSON.stringify({
    //             name, email, schoolName, number, location, schoolAddress, plus: 'No'
    //         })

    //         // const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/3', body, config);
    //         const res = await axios.post('http://localhost:5000/mail/3', body, config);

    //         registrationComplete(res.data.code);
    //         console.log(res.data, '2')

    //         if (res.data.msg === 'OK') setSubmitted(true);

    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    const [btnState, setBtnState] = useState(false)

    const sendMail = async () => {

        try {
            const config = {
                headers: {
                    'Content-type': 'application/json'
                }
            }

            const body = JSON.stringify({
                name, email, schoolName, number, location, schoolAddress, plus: 'No'
            });

            const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/1', body, config);
            // const res = await axios.post('http://localhost:5000/mail/1', body, config);

            registrationComplete(res.data.code);
            // console.log(res.data, '1')

            if (res.data.msg === 'OK') setSubmitted(true);

        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        if (number !== '') {
            setForm({ ...form, phone: number })
        }
        //eslint-disable-next-line
    }, [number])

    if (submitted) return <Navigate to='/success' />

    return (
        <>
            <div className="container mt-5">
                <div className="py-3 rounded-lg">
                    <h3 className="text-center">Delta State School Growth Workshop</h3>
                    <br />
                    <form className="mb-4" onSubmit={onSubmit}>
                        {/* name */}
                        <div className="form-row">
                            <div className="form-group py-1 col-md-6">
                                <input
                                    type="text"
                                    required
                                    className="form-control"
                                    placeholder="Fullname"
                                    name='name'
                                    value={name}
                                    onChange={onChange}
                                />
                            </div>
                            {/* phone number */}
                            <div className="form-group py-1 col-md-6">
                                <PhoneInput
                                    className="form-control"
                                    placeholder="Phone Number"
                                    name='number'
                                    value={number}
                                    onChange={setNumber}
                                    defaultCountry="NG"
                                    required
                                />
                            </div>
                            {/* email */}
                            <div className="form-group py-1 col-md-6">
                                <input
                                    required
                                    type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    name='email'
                                    value={email}
                                    onChange={onChange}
                                />
                            </div>
                            {/* school designation */}
                            <div className="form-group py-1 col-md-6">
                                <select
                                    className="form-control"
                                    required
                                    name='designation'
                                    value={designation}
                                    onChange={onChange}
                                >
                                    <option value="" disabled>
                                        Select Designation
                                    </option>
                                    <option value="School owner">School Owner</option>
                                    <option value="School administrator">School Administrator</option>
                                    <option value="Teacher">Teacher</option>
                                    <option value="Educationist">Educationist</option>
                                    <option value="Prospective school owner">Prospective School Owner</option>
                                </select>
                            </div>

                            {/* SCHOOL INFO */}

                            {/* school location */}
                            <div className="form-group py-1 col-md-12">
                                <input
                                    type="text"
                                    required
                                    className="form-control"
                                    placeholder="Location (State and City)"
                                    name='location'
                                    value={location}
                                    onChange={onChange}
                                />
                            </div>
                            {/* school name */}
                            <div className="form-group py-1 col-md-6">
                                <input
                                    required
                                    type="text"
                                    className="form-control"
                                    placeholder="Name Of School"
                                    name='schoolName'
                                    value={schoolName}
                                    onChange={onChange}
                                />
                            </div>
                            {/* school address */}
                            <div className="form-group py-1 col-md-6">
                                <input
                                    required
                                    type="text"
                                    className="form-control"
                                    placeholder="School Address"
                                    name='schoolAddress'
                                    value={schoolAddress}
                                    onChange={onChange}
                                />
                            </div>

                            <div className="form-group py-1 col-md-12 text-center px-1">
                                <label className='form-check-label'>
                                    <input type={'checkbox'}
                                        className="form-check-input"
                                        onClick={() => setCheckbox(!checkbox)}
                                    />
                                    Would you want to attend with a member of your school? <span>click here</span>
                                </label>
                            </div>

                            <br />
                            {checkbox && (
                                <Extra values={form} checkbox={checkbox} />
                            )}
                            {!checkbox && (
                                <Fragment>
                                    {/* How you heard */}

                                    {/* start */}
                                    <div className="form-group py-1 col-md-12">
                                        <select
                                            className="form-control"
                                            required
                                            name='info'
                                            value={info}
                                            onChange={e => setQuestionSection({ ...questionSection, info: e.target.value })}
                                        >
                                            <option value="" disabled>
                                                How You Heard About The Workshop?
                                            </option>
                                            <option value="facebook">Facebook</option>
                                            <option value="instagram">Instagram</option>
                                            <option value="a friend">A friend</option>
                                            <option value="school invitation">School invitation</option>
                                            <option value="radio">Radio</option>
                                            <option value="billboard">Billboard</option>
                                            <option value="whatsapp">Whatsapp</option>
                                            <option value="google search">Google search</option>
                                            <option value="others">
                                                Others ( please specify )
                                            </option>
                                        </select>
                                    </div>
                                    {info === 'others' && (
                                        <div className="form-group py-1 col-md-12">
                                            <textarea name="info" placeholder='Tell us how you heard about us' rows="5" className='form-control'
                                                onChange={(e) => setQuestionSection({ ...questionSection, others: e.target.value })}
                                            ></textarea>
                                        </div>
                                    )}
                                    {/* end */}

                                    <div className={`form-group py-1 my-2 ${checkbox && 'd-none'}`}>
                                        <p className="col-12 lead font-weight-bold">
                                            Upon registration a <span className='font-italic'>
                                                pass code
                                            </span> will be sent to you, please come with it to the venue of the Workshop
                                        </p>
                                    </div>
                                    <br />
                                    {/* button */}

                                    <button
                                        type="submit"
                                        className='btn btn-primary btn-block mb-5'
                                        disabled={btnState}
                                    >
                                        {btnState ? 'Loading...' : 'Register'}
                                    </button>
                                </Fragment>
                            )}
                        </div>
                    </form>
                    {/* Modal alert */}

                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header>
                            <Modal.Title className='text-danger'>Error</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Please fill every field</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </>
    );
}

const Extra = (values, checkbox) => {

    const { registrationComplete } = useContext(RegistrationContext);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [extraForm, setExtraForm] = useState({
        name: '',
        email: '',
        designation: '',
    });

    const { name, email, designation } = extraForm;

    const [extraNumber, setExtraNumber] = useState('');

    const [submitted, setSubmitted] = useState(false);

    const [btnState, setBtnState] = useState(false)

    const onChange = (e) => {
        setExtraForm({ ...extraForm, [e.target.name]: e.target.value });

    }

    const details = values.values;

    const [exInfo, setExInfo] = useState({
        info: '',
        others: ''
    })

    const { info, others } = exInfo

    const { phone } = details;

    const submit = (e) => {
        e.preventDefault();

        if (info === 'others' && others === '') {
            handleShow();
        } else if (extraNumber === '' || extraNumber === undefined || designation === '') {
            handleShow();
        } else if (email === '' || name === '' || designation === '') {
            handleShow();
        }
        else {
            if (details.email === '' || details.number === '' || details.name === '') {
                handleShow();
            } else if (details.schoolName === '' || details.schoolAddress === '') {
                handleShow();
            } else if (details.location === '' || details.designation === '') {
                handleShow();
            } else if (details.info === '') {
                handleShow();
            } else {

                setBtnState(true)
                sendMail1();
                sendMail2();
                // messageCloud();
                // messageCloud2();
            }

        }

    }

    // const messageCloud = async () => {
    //     try {
    //         const config = {
    //             headers: {
    //                 'Content-type': 'application/json'
    //             }
    //         }

    //         const body = JSON.stringify({
    //             name: details.name, email: details.email, schoolName: details.schoolName, number: phone, location: details.location, schoolAddress: details.schoolAddress, plus: name
    //         })

    //         const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/3', body, config);

    //         registrationComplete(res.data.code);

    //         if (res.data.msg === 'OK') setSubmitted(true);

    //     } catch (err) {
    //         console.log(err)
    //     }
    // }
    // const messageCloud2 = async () => {
    //     try {
    //         const config = {
    //             headers: {
    //                 'Content-type': 'application/json'
    //             }
    //         }

    //         const body = JSON.stringify({
    //             name, email, schoolName: details.schoolName, number: extraNumber, location: details.location, schoolAddress: details.schoolAddress, plus: details.name
    //         })

    //         const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/3', body, config);

    //         registrationComplete(res.data.code);

    //         if (res.data.msg === 'OK') setSubmitted(true);

    //     } catch (err) {
    //         console.log(err)
    //     }
    // }


    const sendMail1 = async () => {

        try {
            const config = {
                headers: {
                    'Content-type': 'application/json'
                }
            }

            const body = JSON.stringify({
                name: details.name, email: details.email, schoolName: details.schoolName, number: phone, location: details.location, schoolAddress: details.schoolAddress, plus: name
            });

            const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/1', body, config);

            // const res = await axios.post('http://localhost:5000/mail/1', body, config);

            registrationComplete(res.data.code);
            // console.log(res.data, '1')

            if (res.data.msg === 'OK') setSubmitted(true);

        } catch (err) {
            console.log(err)
        }
    }
    const sendMail2 = async () => {
        try {
            const config = {
                headers: {
                    'Content-type': 'application/json'
                }
            }

            const body = JSON.stringify({
                name, email, schoolName: details.schoolName, number: extraNumber, location: details.location, schoolAddress: details.schoolAddress, plus: details.name
            });

            const res = await axios.post('https://cloudnotte-form.herokuapp.com/mail/2', body, config);

            // const res = await axios.post('http://localhost:5000/mail/2', body, config);

            registrationComplete(res.data.code);

            if (res.data.msg === 'OK') setSubmitted(true);

        } catch (err) {
            console.log(err)
        }
    }

    if (submitted) return <Navigate to='/success' />

    return (
        <Fragment>
            {/* section2 */}
            <div className="form-group py-1 col-md-6 py-1">
                <input
                    type="text"
                    required
                    className="form-control"
                    placeholder="Fullname"
                    name='name'
                    value={name}
                    onChange={onChange}
                />
            </div>
            {/* phone number */}
            <div className="form-group py-1 col-md-6">
                <PhoneInput
                    className="form-control"
                    placeholder="Phone Number"
                    name='number'
                    value={extraNumber}
                    onChange={setExtraNumber}
                    defaultCountry="NG"
                    required
                />
            </div>
            {/* email */}
            <div className="form-group py-1 col-md-6">
                <input
                    required
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name='email'
                    value={email}
                    onChange={onChange}
                />
            </div>
            {/* school designation */}
            <div className="form-group py-1 col-md-6">
                <select
                    className="form-control"
                    required
                    name='designation'
                    value={designation}
                    onChange={onChange}
                >
                    <option value="" disabled>
                        Select Designation
                    </option>
                    <option value="School owner">School Owner</option>
                    <option value="School administrator">School Administrator</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Educationist">Educationist</option>
                    <option value="Prospective school owner">Prospective School Owner</option>
                </select>
            </div>

            {/* start */}
            <div className="form-group py-1 col-md-12">
                <select
                    className="form-control"
                    required
                    name='info'
                    value={info}
                    onChange={e => setExInfo({ ...exInfo, info: e.target.value })}
                >
                    <option value="" disabled>
                        How You Heard About The Workshop?
                    </option>
                    <option value="facebook">Facebook</option>
                    <option value="instagram">Instagram</option>
                    <option value="a friend">A friend</option>
                    <option value="school invitation">School invitation</option>
                    <option value="radio">Radio</option>
                    <option value="billboard">Billboard</option>
                    <option value="whatsapp">Whatsapp</option>
                    <option value="google search">Google search</option>
                    <option value="others">
                        Others ( please specify )
                    </option>
                </select>
            </div>
            {info === 'others' && (
                <div className="form-group py-1 col-md-12">
                    <textarea name="info" placeholder='Tell us how you heard about us' rows="5" className='form-control'
                        onChange={(e) => setExInfo({ ...exInfo, others: e.target.value })}
                    ></textarea>
                </div>
            )}
            {/* end */}

            <div className={`form-group py-1 my-2 ${!checkbox && 'd-none'}`}>
                <p className="col-12 lead font-weight-bold">
                    Upon registration a <span className='font-italic'>
                        pass code
                    </span> will be sent to you, please come with it to the venue of the Workshop
                </p>
            </div>

            <button
                type="submit"
                className='btn btn-primary btn-block mb-5'
                onClick={submit}
                disabled={btnState}
            >
                {btnState ? 'Loading...' : 'Register'}
            </button>

            {/* Modal alert */}

            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title className='text-danger' >Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Please fill every field</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default Form;
